import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { SharedCommonModule } from './shared-common.module';

import { MatTableModule } from '@angular/material/table';
import { MatSortModule } from '@angular/material/sort';
import { MatTooltipModule } from '@angular/material/tooltip';
import { MatIconModule } from '@angular/material/icon';
import { MatButtonModule } from '@angular/material/button';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { MatProgressBarModule } from '@angular/material/progress-bar';

import { TableComponent } from './components/table/table.component';
import { TableLandingComponent } from './components/table-landing/table-landing.component';
import { FormsCommonModule } from './forms-common.module';

@NgModule({
  imports: [
    CommonModule,
    FormsCommonModule,
    SharedCommonModule,
    MatTableModule,
    MatCheckboxModule,
    MatTooltipModule,
    MatIconModule,
    MatButtonModule,
    MatProgressBarModule,
    MatSortModule
  ],
  declarations: [TableComponent, TableLandingComponent],

  exports: [CommonModule, MatTableModule, MatSortModule, TableComponent, TableLandingComponent]
})
export class TablesCommonModule {}
